import Div from "@jumbo/shared/Div/Div";
import MuiTableWrapper from "app/pages/Docgen/components/common/mui-table-wrapper/MuiTableWrapper";
import {useEffect, useState} from "react";
import {get} from "../../../common/network";


const RelatedContactsTabs = ({id}) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [data, setData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [rowsSelection, setRowsSelection] = useState([]);

    const columns = [
        {
            field: "contact_type",
            header: "Contact Type",
            sort: false,
            render: (value, row) => row.party?.contact_type
        },
        {
            field: "name",
            header: "Full Name",
            sort: false,
            render: (value, row) => row.party?.name
        },
        {
            field: "attorney_role_type",
            header: "Attorney Role Type",
            sort: false,
            render: (value, row) => row.party?.attorney_role_type
        },
        {
            field: "party_type",
            header: "Role",
            sort: false
        },
        {
            field: "role_type",
            header: "Role Type",
            sort: false,
            render: (value, row) => row.party?.role_type
        },

        {
            field: "email",
            header: "Office Email",
            sort: false,
            render: (value, row) => row.party?.office_email
        }
    ];

    const fetchData = async () => {
        setIsFetching(true);
        try {
            // page++
            const response = await get(`docgen/matters/${id}`);
            const matterParties = {};
            matterParties.data = response?.data?.matter_parties;
            setData(response?.data?.matter_parties);
        } catch (error) {
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Div sx={{height: "90vh", overflow: "auto"}}>
            <div id="contacts-tab" name="contacts-tab">
                <MuiTableWrapper
                    columns={columns}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    hasCheckboxesColumn={false}
                    searchValue={""}
                    filterColumn={"all"}
                    data={data}
                    isFetching={isFetching}
                    rowsSelection={rowsSelection}
                    setRowsSelection={setRowsSelection}
                    // dateValue={dateValue}
                />
            </div>
        </Div>
    );
};


export default RelatedContactsTabs;